import { orchestrator } from 'satcheljs';
import { onSurfaceRightClick } from '../actions/surfaceOnClickActions';
import { openSurfaceContextMenu } from 'owa-calendar-surface-view-store';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Opens the surface context menu
 *
 */
orchestrator(onSurfaceRightClick, actionMessage => {
    if (isFeatureEnabled('mon-cal-surface-contextmenu')) {
        openSurfaceContextMenu(
            actionMessage.start,
            actionMessage.end,
            actionMessage.isAllDay,
            actionMessage.event,
            actionMessage.selectedCalendarFolderId
        );
    }
});
